<template>
  <div>
    <div class="content-devx">
      <DxForm
        id="costForm"
      >
        <DxGroupItem
          css-class="content-combo"
          :caption="$t('LeftPanel_subtitle_locationClimate')"
          :col-count="1"
        >
          <DxSimpleItem
            name="agroClimatic_station"
            :data-field="$t('agroClimatic_station')"
            editor-type="dxSelectBox"
            :editor-options="{
              items: itemsClimate,
              displayExpr: 'source',
              valueExpr: 'id',
              onValueChanged: onChangeStationClimate,
              searchEnabled: true,
              placeholder: $t('placeholder_station'),
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
        </DxGroupItem>
      </DxForm>
      <div class="showButtonContent">
        <DxButton
          name="btnSignIn"
          class="botonSecundary"
          style="color:#FFFFFF"
          @click="show"
        >
          {{ $t("show") }}
        </DxButton>
      </div>
    </div>
    <div
      class="transparent headers-initial"
      style="margin: 2rem 0 1rem;"
    >
      <DxDataGrid
        id="climateGH"
        :key="tableKey"
        :data-source="dataSource"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="false"
        :column-auto-width="true"
        :row-alternation-enabled="false"
        :word-wrap-enabled="true"
        no-data-text="Sin datos"
        @file-saving="onFileSaving"
      >
        <DxSelection
          mode="single"
        />
        <DxExport
          :enabled="true"
          :texts="{exportAll: 'Exportar',}"
          file-name="Base de Datos - LOCALIZACIÓN Y CLIMA - Invernadero"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :show-info="true"
          info-text="Página {0} de {1} ({2} días)"
          :allowed-page-sizes="['5', '10', '20', '30', '60']"
        />
        <DxHeaderFilter :visible="true" />
        <DxSearchPanel
          text=""
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxColumnFixing :enabled="true" />
        <DxColumn
          data-field="yearoftheday"
          :caption="$t('dataBaseClimate.datagrid_yearOfDay')"
          :allow-header-filtering="false"
          alignment="left"
          css-class="bold"
        />
        <DxColumn
          data-field="tmax"
          :caption="$t('dataBaseClimate.datagrid_tMax')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="tmin"
          :caption="$t('dataBaseClimate.datagrid_tMin')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="rs"
          :caption="$t('dataBaseClimate.datagrid_rs_ext')"
          :allow-header-filtering="false"
          alignment="left"
        />
      </DxDataGrid>
    </div>
    <DxPopUpStation />
  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import { mapActions, mapState } from 'vuex';
import DxPopUpStation from '../../registerProject/registerProjectGreenhouse/popUpStation/index.vue';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_TABLES } from '../../../js/constants';

export default {
  name: 'ClimateGreenHouse',
  components: {
    DxButton,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxPopUpStation,
  },
  data() {
    return {
      source: null,
      itemsClimate: [],
      dataSource: [],
      tableKey: 0,
      NUMBER_OF_DECIMALS,
      TO_FIXED_DECIMALS_IN_TABLES,
    };
  },
  computed: {
    ...mapState('authentication', ['profile']),
    ...mapState('ProjectGreenHouse', ['provinces', 'stationClimate', 'province', 'climate', 'climateSource']),
  },
  async mounted() {
    try {
      this.$f7.preloader.show();
      await this.fetchDatabaseClimate();
      const prepareItemsClimate = [];
      if (this.climate && this.climate.mean_year) {
        prepareItemsClimate.push({
          id: this.climate.mean_year,
          source: this.getProvinceName(this.climate.mean_year),
        });
      }
      if (this.climate && this.climate.db_climate && this.climate.db_climate.length) {
        this.climate.db_climate.forEach((item) => {
          if (item.project_type === 'GH') {
            prepareItemsClimate.push({
              id: item.id,
              source: item.source,
            });
          }
        });
      }
      this.itemsClimate = prepareItemsClimate;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    getProvinceName(meanYear) {
      return `${meanYear} (El Ejido, Almería)`;
    },
    async onChangeProvince(e) {
      if (typeof e.event !== 'undefined') {
        try {
          this.$f7.preloader.show();
          this.setDatabaseProvince(e.value);
          await this.fetchDatabaseClimate(e.value);
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
    onChangeStationClimate(e) {
      if (typeof e.event !== 'undefined') {
        if (e.value === 'Añadir') {
          this.setEnabledPopUpStation(true);
        } else {
          this.source = e.value;
        }
      }
    },
    async show() {
      try {
        this.$f7.preloader.show();
        if (this.source) {
          this.dataSource = [];
          if (this.climate && this.climate.mean_year === this.source) {
            await this.fetchDatabaseClimateSourceMeanYearGh();
          } else {
            await this.fetchDatabaseClimateSource(this.source);
          }
          if (this.climateSource && this.climateSource.parameters) {
            const params = this.climateSource.parameters;
            if (params && params.TEMPERATURE_MAX
                && params.TEMPERATURE_MAX.values
                && params.TEMPERATURE_MAX.values.length) {
              params.TEMPERATURE_MAX.values.forEach((item) => {
                this.dataSource.push({
                  yearoftheday: item.day,
                  tmax: Number(item.value.toFixed(this.NUMBER_OF_DECIMALS)),
                });
              });
            }
            if (params && params.TEMPERATURE_MIN
                && params.TEMPERATURE_MIN.values
                && params.TEMPERATURE_MIN.values.length) {
              params.TEMPERATURE_MIN.values.forEach((item, index) => {
                try {
                  this.dataSource[index].tmin = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            }
            if (params && params.SOLAR_RADIATION
                  && params.SOLAR_RADIATION.values
                  && params.SOLAR_RADIATION.values.length) {
              params.SOLAR_RADIATION.values.forEach((item, index) => {
                try {
                  this.dataSource[index].rs = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            }
            this.tableKey += 1;
          }
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, 'Base de Datos - LOCALIZACIÓN Y CLIMA - Invernadero.xlsx').then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
    ...mapActions('ProjectGreenHouse', ['fetchProvinces', 'setDatabaseProvince', 'setEnabledPopUpStation',
      'fetchDatabaseClimate', 'fetchDatabaseClimateSource', 'fetchDatabaseClimateSourceMeanYearGh']),
  },
};
</script>
<style lang="scss" scoped>
@import "./climateGreenHouse.scss";
</style>
